import React from 'react';
import { DisabledTag } from '@nile/components';
import { Link } from '@superops/ui-design-system';

function KbNumberCell(props) {
  const { cell } = props;
  const cellOriginal = cell?.row?.original;
  const val = cellOriginal?.patchDetail
    ? cellOriginal.patchDetail.kbNumbers[0]?.kbNumber
    : cellOriginal?.kbNumbers[0]?.kbNumber;
  const microsoftURL = `https://support.microsoft.com/en-us/help/${val}`;
  const redirectToURL = () => {
    window.open(microsoftURL, '_blank');
  };
  return val ? (
    <>
      <Link
        removeUnderline
        onClick={redirectToURL}
        external
        fontWeight="normal"
      >
        {val}
      </Link>
    </>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default KbNumberCell;
